package ai.wagemix.components.layouts

import ai.wagemix.web.theme.WMArticleWidthVar
import ai.wagemix.web.theme.WMBodyTextStyle
import androidx.compose.runtime.Composable
import com.fsryan.foundation.web.theme.fs
import com.varabyte.kobweb.compose.css.Overflow
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.borderLeft
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.lineHeight
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.maxWidth
import com.varabyte.kobweb.compose.ui.modifiers.overflow
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.core.PageContext
import com.varabyte.kobweb.core.layout.Layout
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.toModifier
import com.varabyte.kobweb.silk.theme.colors.palette.toPalette
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.cssRem
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.Article

/** Penpot `Methodology`: an article column of 720 inside the marketing layout. */
val MarkdownStyle = CssStyle {
    base {
        Modifier.fillMaxWidth().maxWidth(WMArticleWidthVar.value()).margin(leftRight = 0.px, topBottom = 2.cssRem)
            .lineHeight(1.6)
    }
    cssRule("h1") { Modifier.fontSize(2.25.cssRem).fontWeight(700).lineHeight(1.15).margin(bottom = 1.5.cssRem) }
    cssRule("h2") { Modifier.fontSize(1.75.cssRem).fontWeight(600).lineHeight(1.2).margin(top = 2.cssRem, bottom = 1.cssRem) }
    cssRule("h3") { Modifier.fontSize(1.25.cssRem).fontWeight(600).lineHeight(1.3).margin(top = 1.5.cssRem, bottom = 0.75.cssRem) }
    cssRule("p") { Modifier.margin(bottom = 1.cssRem) }
    cssRule("ul, ol") { Modifier.margin(bottom = 1.cssRem).padding(left = 1.5.cssRem) }
    cssRule("li") { Modifier.margin(bottom = 0.5.cssRem) }
    cssRule("a") { Modifier.color(colorMode.toPalette().fs.primary) }
    cssRule("blockquote") {
        Modifier.borderLeft(width = 4.px, style = LineStyle.Solid, color = colorMode.toPalette().fs.outlineVariant)
            .padding(left = 1.cssRem).margin(bottom = 1.cssRem).color(colorMode.toPalette().fs.onSurfaceVariant)
    }
    cssRule("code") {
        Modifier.backgroundColor(colorMode.toPalette().fs.surfaceContainer).borderRadius(4.px).padding(leftRight = 0.3.cssRem)
    }
    cssRule("pre") {
        Modifier.backgroundColor(colorMode.toPalette().fs.surfaceContainer).borderRadius(8.px).padding(1.cssRem).overflow { x(Overflow.Auto) }
    }
    cssRule("table") { Modifier.fillMaxWidth().margin(bottom = 1.cssRem) }
    cssRule("th, td") { Modifier.padding(0.5.cssRem) }
}

@Layout
@Composable
fun MarkdownLayout(ctx: PageContext, content: @Composable () -> Unit) {
    MarketingLayout(ctx) {
        Article(attrs = MarkdownStyle.toModifier().then(WMBodyTextStyle.toModifier()).toAttrs()) {
            content()
        }
    }
}
